import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2f8073cc&scoped=true&"
import script from "./Home.js?vue&type=script&lang=js&"
export * from "./Home.js?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=2f8073cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8073cc",
  null
  
)

export default component.exports